export default __webpack_public_path__ + "assets/a997cce47acb07c54959a33af1bb23e7/02.jpg";